import getFurnishings from './staging/get-furnishings.js'
import replaceFurniture from './staging/replace-furniture.js'
import getFurnitureAlternatives from './staging/get-furniture-alternatives.js'

var staging = {
  getFurnishings: getFurnishings,
  getFurnitureAlternatives: getFurnitureAlternatives,
  replaceFurniture: replaceFurniture
}

export default staging
